import styles from './BigCard.module.css'

function BigCard(props){

    return (
            <div className={styles.card}>
                <div className={styles.backgroundShape}></div>
                <div className={styles.cardContent}>
                    <span className={styles.label}>{props.name}</span>
                    <span className={styles.value}>{props.value}</span>
                </div>
            </div>
    )
}

export default BigCard